/**
 * Whether the client accepts ClaimsChallengeMessages
 */
export const acceptsClaimsChallengeMessages = '_acceptsClaimsChallengeMessages';
/**
 * Whether the client accepts SeedingStatusChangeMessages
 */
export const acceptsSeedingStatusChangeMessages = '_acceptsSeedingStatusChangeMessages';
//# sourceMappingURL=client-feature-flights.js.map